import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58404 21.8737V15.2238H7.52015V12.1677H9.58404V10.851C9.58404 7.44716 11.124 5.87105 14.464 5.87105C15.0963 5.87105 16.1879 5.99494 16.6363 6.11883V8.88717C16.4001 8.86329 15.9879 8.85105 15.4801 8.85105C13.8401 8.85105 13.2079 9.47106 13.2079 11.0871V12.1677H16.4763L15.9163 15.2233H13.2124V22.0954C18.1637 21.4956 22 17.2797 22 12.1677C22 6.64494 17.5228 2.16772 12 2.16772C6.47722 2.16772 2 6.64494 2 12.1677C2 16.8576 5.22813 20.793 9.58404 21.8737Z"
  })));
};

export { SvgSocialFacebook as ReactComponent };
//# sourceMappingURL=social-facebook.svg.js.map
